import React, { useState } from "react";
import { FaQuestionCircle } from "react-icons/fa";

const DeviceEvaluationForm = () => {
  const [popupContent, setPopupContent] = useState(null);

  const openPopup = (content) => {
    setPopupContent(content);
  };

  const closePopup = () => {
    setPopupContent(null);
  };

  return (
    <div className="container mx-auto p-4 max-w-7xl  text-white rounded-lg shadow-lg mb-5">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Sol Panel */}
        <div className="p-6 rounded-lg flex flex-col items-center">
          <div className="w-96 h-96  flex items-center justify-center rounded-lg mb-4">
            <img
              src="https://cihaz-sat.easycep.com/images/webp/iphone_telefon.webp"
              alt="/"
            />
          </div>
          <div className="w-full bg-gray-800 p-4 text-center rounded-lg">
            <p className="text-lg font-bold ">Ön Teklif</p>
            <p className="text-2xl font-extrabold">9750 ₺</p>
          </div>
        </div>

        {/* Sağ Panel */}
        <div className="lg:col-span-2 bg-white text-black p-2 rounded-lg relative">
          {/* Başlık */}
          <h2 className="text-2xl font-bold mb-2 text-center">
            Apple iPhone 11 Pro Max
          </h2>

          {/* Form */}
          <div className="grid grid-cols-1 gap-6">
            {/* Hafıza */}
            <div>
              <p className="font-semibold text-lg mb-1 flex items-center">
                Hafızası ne kadar?
                <FaQuestionCircle
                  className="ml-2 text-blue-500 cursor-pointer"
                  onClick={() =>
                    openPopup(
                      "Hafıza, cihazın depolama kapasitesini ifade eder."
                    )
                  }
                />
              </p>

              <div className="grid grid-cols-3 gap-4">
                {["128 GB", "256 GB", "512 GB"].map((option) => (
                  <button
                    key={option}
                    className="px-4 py-2 border rounded-lg hover:bg-gray-200 transition-colors focus:ring-2 focus:ring-blue-500 text-center w-full"
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>

            {/* Cihaz Açılıyor mu */}
            <div>
              <p className="font-semibold text-lg mb-1 flex items-center">
                Cihazınız Açılıyor mu?
                <FaQuestionCircle
                  className="ml-2 text-blue-500 cursor-pointer"
                  onClick={() =>
                    openPopup(
                      "Cihazınızın açılıp açılmadığı, cihazın temel işlevselliğini etkileyen önemli bir kriterdir."
                    )
                  }
                />
              </p>

              <div className="grid grid-cols-2 gap-4">
                {["Hayır", "Evet"].map((option) => (
                  <button
                    key={option}
                    className="px-4 py-2 border rounded-lg hover:bg-gray-200 transition-colors focus:ring-2 focus:ring-blue-500 text-center w-full"
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>

            {/* Ekran Durumu */}
            <div>
              <p className="font-semibold text-lg mb-1 flex items-center">
                Ekran Durumu
                <FaQuestionCircle
                  className="ml-2 text-blue-500 cursor-pointer"
                  onClick={() =>
                    openPopup(
                      "Ekran durumu cihazınızın görsel arayüzünün fiziksel durumunu ifade eder. Kırık, çizikli veya sağlam gibi durumlar burada değerlendirilir."
                    )
                  }
                />
              </p>

              <div className="grid grid-cols-3 gap-4">
                {["Kırık", "Çizikler var", "Sağlam"].map((option) => (
                  <button
                    key={option}
                    className="px-4 py-2 border rounded-lg hover:bg-gray-200 transition-colors focus:ring-2 focus:ring-blue-500 text-center w-full"
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>

            {/* Kozmetik Durum */}
            <div>
              <p className="font-semibold text-lg mb-1 flex items-center">
                Kozmetik durumu nasıl?
                <FaQuestionCircle
                  className="ml-2 text-blue-500 cursor-pointer"
                  onClick={() =>
                    openPopup(
                      "Kozmetik durum, cihazın dış görünümünün temizliği ve estetik durumunu ifade eder."
                    )
                  }
                />
              </p>

              <div className="grid grid-cols-4 gap-4">
                {["Kötü", "İyi", "Çok İyi", "Mükemmel"].map((option) => (
                  <button
                    key={option}
                    className="px-4 py-2 border rounded-lg hover:bg-gray-200 transition-colors focus:ring-2 focus:ring-blue-500 text-center w-full"
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <p className="font-semibold text-lg mb-1 flex items-center">
                Kameraları çalışıyor mu?
                <FaQuestionCircle
                  className="ml-2 text-blue-500 cursor-pointer"
                  onClick={() =>
                    openPopup(
                      "Cihazın ön ve arka kameralarının çalışıp çalışmadığını belirtir. Örneğin, ön kamera, arka kamera veya her ikisinin durumu burada değerlendirilir."
                    )
                  }
                />
              </p>
              <div className="grid grid-cols-3 gap-4">
                {[
                  "Ön Kamera Arızalı",
                  "Arka Kamera Arızalı",
                  "Hepsi Çalışıyor",
                ].map((option) => (
                  <button
                    key={option}
                    className="px-4 py-2 border rounded-lg hover:bg-gray-200 transition-colors focus:ring-2 focus:ring-blue-500 text-center w-full"
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <p className="font-semibold text-lg mb-1 flex items-center">
                Face ID çalışıyor mu?
                <FaQuestionCircle
                  className="ml-2 text-blue-500 cursor-pointer"
                  onClick={() =>
                    openPopup(
                      "Face ID, cihazın yüz tanıma özelliğidir. Bu özelliğin çalışıp çalışmadığını belirtin. Çalışmıyorsa, cihazınızı farklı bir değerlendirmeye tabi tutabiliriz."
                    )
                  }
                />
              </p>
              <div className="grid grid-cols-2 gap-4">
                {["Hayır", "Evet"].map((option) => (
                  <button
                    key={option}
                    className="px-4 py-2 border rounded-lg hover:bg-gray-200 transition-colors focus:ring-2 focus:ring-blue-500 text-center w-full"
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <p className="font-semibold text-lg mb-1 flex items-center">
                Batarya Durumu?
                <FaQuestionCircle
                  className="ml-2 text-blue-500 cursor-pointer"
                  onClick={() =>
                    openPopup(
                      "Batarya durumu, cihazın pil sağlığını ifade eder. Örneğin, bataryanın kapasite yüzdesi burada değerlendirilir. Daha yüksek bir yüzde, daha uzun pil ömrü anlamına gelir."
                    )
                  }
                />
              </p>
              <div className="grid grid-cols-4 gap-4">
                {["0-85", "85-90", "90-95", "95-100"].map((option) => (
                  <button
                    key={option}
                    className="px-4 py-2 border rounded-lg hover:bg-gray-200 transition-colors focus:ring-2 focus:ring-blue-500 text-center w-full"
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Devam Et Butonu */}
          <button className="w-full mt-6 bg-yellow-500 text-black py-3 rounded-lg font-bold hover:bg-yellow-600 transition-colors">
            DEVAM ET
          </button>
        </div>
      </div>

      {popupContent && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-xl shadow-lg text-gray-800 max-w-md w-full relative">
            {/* Kapat Butonu */}
            <button
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition duration-200"
              onClick={closePopup}
              aria-label="Close Popup"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            {/* Popup Başlık */}
            <h3 className="text-lg font-semibold mb-4 text-center">
              Bilgilendirme
            </h3>

            {/* Popup İçeriği */}
            <p className="text-sm text-center">{popupContent}</p>

            {/* Footer ve Tamam Butonu */}
            <div className="mt-6 flex justify-center">
              <button
                className="px-6 py-2 bg-blue-500 text-white text-sm font-medium rounded-lg shadow hover:bg-blue-600 focus:ring-2 focus:ring-blue-300 focus:outline-none transition duration-200"
                onClick={closePopup}
              >
                Tamam
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeviceEvaluationForm;
